import resource from '../resource';

//create ,get ,query ,remove & update
export const ccOrdersApi = resource('/order/list');
export const changeCCOrderStatusApi = resource('/change-order-status/');
